module.exports = __webpack_public_path__ + "img/发明创业奖-创新奖_一等奖.8ffde370.png";